import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const Wrapper = styled.div`
  flex: 470;
  @media only screen and (max-width: 991px) {
    width: 100%;
  }
  tr {
    border-top: solid 5px ${themeGet('color.1', '#ffffff')};
  }
  .CalendarDay__selected {
    background: ${themeGet('text.13', '#121a2c')};
    color: ${themeGet('color.1', '#ffffff')};
  }
  .CalendarDay__selected_span {
    background: ${themeGet('border.9', '#e0e0e0')};
  }
  .CalendarDay__default {
    border: none;
  }
  .CalendarDay__blocked_out_of_range {
    color: ${themeGet('text.12', '#828282')} !important;
  }
  .CalendarMonth_table {
    margin-top: 13px;
  }
  .DateInput_input__focused {
    border-bottom: none;
  }
  .DateRangePicker {
    width: 100%;
  }
  .DateRangePicker_picker {
    top: 70px !important;
    left: 0px !important;
  }
  .DateRangePickerInput {
    display: flex;
  }

  .dates-wrapper {
    display: flex;
    flex-direction: row;
    @media only screen and (max-width: 991px) {
      width: 100%;
    }
  }
  .DayPickerNavigation {
    display: flex;
    top: 22px;
    justify-content: space-between;
  }
  .CalendarMonth_caption {
    font-size: 14px;
  }
  .DayPicker_weekHeader {
    color: ${themeGet('text.12', '#828282')};
    font-size: 13px;
    text-transform: uppercase;
  }
`;

export const NavButton = styled.a`
  width: 90px;
  text-align: center;
  .anticon svg {
    width: 24px;
    height: 24px;
    fill: ${themeGet('color.38', '#BDBDBD')};
    background-color: ${themeGet('text.13', '#121a2c')};
    border-radius: 50%;
  }

  :hover {
    opacity: 0.5;
  }
`;

export default Wrapper;
